import PredictionDetails from "./predictionDetails";

export default PredictionDetails;
